import React, { useEffect, useRef, useState } from 'react';


const CodeInput = ({codeLength = 5, size=42, onChange}: {codeLength?: number, size: number, onChange: (code: string)=>void}) => {
    const [code, setCode] = useState<string[]>([]);
    const digitRefs = useRef<HTMLInputElement[]>([])

    useEffect(() => {
        setCode(new Array(codeLength).fill(""))
    }, [codeLength])

    function handleCodeInput(value: string, index: number) {
        const upperValue = value.toUpperCase().slice(0, 1);

        const newCode = code.map((v, idx) =>
            idx === index ? upperValue : v
        );

        setCode(newCode);
        onChange?.(newCode.join(""));

        if (upperValue && index < codeLength - 1) {
            digitRefs.current[index + 1]?.focus();
        }
    }

    function handleKeyPress(event: React.KeyboardEvent<HTMLInputElement>, index: number){
        if (digitRefs) {

            if (index  > 0 && ((event.key === "Backspace" && !code[index])|| event.key === "ArrowLeft")) {
                digitRefs.current[index-1]?.focus();
            }

            else if (index  < codeLength && ((!Number.isNaN(+event.key) && code[index]) || event.key === "ArrowRight")) {
                digitRefs.current[index+1]?.focus();
            }
        }
    }


    //means you can paste the code in
    function handlePaste(event: React.ClipboardEvent<HTMLInputElement>) {
        event.preventDefault();

        const pastedCode = event.clipboardData.getData("text");
        const codeDigits = pastedCode.replace(/[^a-zA-Z0-9]/g, "").toUpperCase().slice(0, codeLength).split("");
        
        if (!codeDigits.length) return;

        const newCode = new Array(codeLength).fill("");

        codeDigits.forEach((digit, index) => {
            newCode[index] = digit;
            if (digitRefs.current[index]) {
                digitRefs.current[index].value = digit;
            }
        });

        setCode(newCode);
        onChange?.(newCode.join(""));

        const nextIndex = Math.min(codeDigits.length, codeLength - 1);
        digitRefs.current[nextIndex]?.focus();
    }

    return (
        <div className='tc-code-Input'>
            {code.map((value , index) => (
                <input
                    key={`code-input-character-${index}`}
                    style={{"--input-character-size": `${size}px`} as any}
                    data-testid="recovery-form-code-input-item"
                    className="tc-code-input-item"
                    aria-label={`Input verification code value at index ${index + 1}`}
                    type="text"
                    ref={(el: HTMLInputElement) => {digitRefs.current[index] = el!}}
                    autoFocus={index === 0}
                    id={`input-${index}`}
                    value={value}
                    maxLength={1}
                    pattern='[a-zA-Z0-9]{1}'
                    inputMode="numeric"
                    onKeyDown={e => {
                    if (e.ctrlKey || e.metaKey) return;

                    const isValid = /^[a-zA-Z0-9]$/.test(e.key);

                    if (!isValid && e.key.length === 1) {
                        e.preventDefault();
                    }
                    }}                    
                    onChange={(event) => handleCodeInput(event.target.value.toUpperCase(), index)}
                    onKeyUp={(event) => handleKeyPress(event, index)}
                    onFocus={e => e.target.select()}
                    onPaste={handlePaste}
                />
            ))}
        </div>
    )
}

export default CodeInput